import { QuoteRequestLineFormData } from "#modules/quoteRequestLines/types/QuoteRequestLineFormData";
import { IndustrialProcessSchema, IndustrialProcessType } from "shared";

const assemblyProcessSteps: IndustrialProcessType[] = [
  IndustrialProcessSchema.enum.ASSEMBLING,
  IndustrialProcessSchema.enum.CRIMPING,
  IndustrialProcessSchema.enum.PRESSING,
  IndustrialProcessSchema.enum.WELDING,
];

export const useAssemblyAlert = ({
  processSteps,
  hasChildren,
}: {
  processSteps: QuoteRequestLineFormData["processSteps"] | undefined;
  hasChildren: boolean;
}) => {
  const hasConsumableProcessSteps = processSteps?.some((processStep) =>
    assemblyProcessSteps.includes(processStep.industrialProcess),
  );

  const shouldShowAssemblyAlert = hasChildren && !hasConsumableProcessSteps;

  return {
    shouldShowAssemblyAlert,
  };
};
